import styled from "@emotion/styled";
import React from "react";
import UI from "@mile-meeting/mile-ui";

type SubPolicySettingBlockProps = {
  title?: string;
  description?: string;
  rightChildren?: React.ReactNode;
  styles?: React.CSSProperties;
};
const SubPolicySettingBlock: React.FC<SubPolicySettingBlockProps> = ({
  title,
  description,
  rightChildren = <></>,
  styles,
}) => {
  return (
    <Container style={styles}>
      <LeftSideContainer>
        <UI.Typography type="body01 normal" color="var(--alias-color-label-normal)">
          {title}
        </UI.Typography>
        <UI.Typography type="body02 normal" color="var(--alias-color-label-alternative)">
          {description}
        </UI.Typography>
      </LeftSideContainer>
      {rightChildren && rightChildren}
    </Container>
  );
};

export default React.memo(SubPolicySettingBlock);

const Container = styled.div`
  display: flex;
  padding: 12px 28px 20px 40px;
  align-items: center;
  gap: 10px;
  align-self: stretch;
  overflow: visible;
`;

const LeftSideContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  flex: 1 0 0;
`;
